import ProductImage from "../ProductImage";
import "./AddToBasketModal.scss";

function AddToBasketModal({ product, quantityInBasket, onClose }) {

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-bask" onClick={(e) => e.stopPropagation()}>

        {/* ✅ HEADER */}
        <div className="modal-header success">
          <div className="header-left">
            <i className="bx bx-check-circle" />
            <span>Produit ajouté avec succès</span>
          </div>

          {/* ❌ CLOSE BUTTON */}
          <button className="close-btn" onClick={onClose}>
            <i className="bx bx-x" />
          </button>
        </div>

        {/* ✅ PRODUCT INFO */}
        <div className="modal-body">
          <ProductImage productId={product._id} />

          <div className="info">
            <h3>{product.name}</h3>
            <p className="desc">{product.description}</p>

            <div className="quantity">
              <span>
                <b>Quantité ajoutée :</b> 1
              </span>
              <span>
                <b>Dans le panier :</b> {quantityInBasket}
              </span>
            </div>
          </div>
        </div>

        {/* ✅ ACTIONS */}
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Continuer les achats
          </button>
          <button
            className="btn-primary"
            onClick={() => (window.location.href = "/card")}
          >
            Voir le panier
          </button>
        </div>

      </div>
    </div>
  );
}

export default AddToBasketModal;
